import { LogInResponseDTO } from '../DTO/authDTO';

export enum AccessProfile {
    Administrator = 1,
    Owner = 2,
    Athlete = 3,
    Guest = 4,
    OpenSea = 5,
    PointOfSale = 6,
    Dependent = 7,
    SmartShareGuest = 8,
    Partner = 9,
    TAC_OWNER = 12,
    TAC_DEPENDENT = 13
}

export function isProprietarioProfile(user?: LogInResponseDTO): boolean {
    const key = user?.accessProfile?.enumKey;
    return key === AccessProfile.Owner || key === AccessProfile.TAC_OWNER;
}
export function makeAccessProfile(user?: LogInResponseDTO) {
    if (!user || !user.accessProfile) {
        return 'Perfil desconhecido'; // Retorna um valor padrão caso user ou accessProfile seja indefinido
    }

    switch (user.accessProfile.enumKey) {
        case AccessProfile.Administrator:
            return 'administrador';
        case AccessProfile.Guest:
            return 'convidado';
        case AccessProfile.OpenSea:
            return 'mar aberto';
        case AccessProfile.Owner:
            return 'proprietário';
        case AccessProfile.Athlete:
            return 'Atleta';
        case AccessProfile.Dependent:
            return 'dependente';
        case AccessProfile.PointOfSale:
            return 'ponto de venda';
        case AccessProfile.SmartShareGuest:
            return 'smart share';
        case AccessProfile.Partner:
            return 'Sócio';
        case AccessProfile.TAC_OWNER:
            return 'Proprietário TAC';
        case AccessProfile.TAC_DEPENDENT:
            return 'Dependente TAC';
        default:
            return user.accessProfile.name;
    }
}
